import "../css/Footer.css";
import { Link } from "react-router-dom";
import { BsInstagram, BsLinkedin, BsReddit, BsTwitterX } from "react-icons/bs";



function Footer() {
    return (
        <footer className="site-footer text-light py-5">
            <div className="container">

                <div className="row gy-4">
                    {/* Company Info */}
                    <div className="col-md-4">
                        <h5 className="fw-bold mb-3 text-white">Irtika Shrey Consulting</h5>
                        <p className="text-light">
                            Helping individuals and families with relationship clarity, personal decision-making, and conflict resolution.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div className="col-md-4">
                        <h6 className="fw-bold mb-3 text-white">Quick Links</h6>
                        <ul className="list-unstyled footer-links">
                            <li><Link to="/about">About</Link></li>
                            <li><Link to="/what-we-offer">What We Offer</Link></li>
                            <li><Link to="/book-session">Book a Session</Link></li>
                            <li><Link to="/contact">Contact</Link></li>
                        </ul>

                    </div>



                    {/* Contact Info */}

                    <div className="col-md-4">

                        <h6 className="fw-bold mb-3 text-white">Get in Touch</h6>
                        <div className="d-flex gap-3 mt-3">



                            <a href="https://www.linkedin.com/company/irtika-shrey-consulting/?viewAsMember=true"
                                target="_blank" rel="noreferrer"
                                className="text-white text-decoration-none">
                                <BsLinkedin size={24} />
                            </a>
                            <a href="https://www.reddit.com/user/IrtikaShrey/"
                                target="_blank" rel="noreferrer"
                                className="text-white text-decoration-none">
                                <BsReddit size={24} />
                            </a>

                            <a href="https://www.instagram.com/irtikashrey/"
                                target="_blank" rel="noreferrer"
                                className="text-white text-decoration-none">
                                <BsInstagram size={24} />
                            </a>

                            <a href="https://x.com/IrtikaShrey"
                                target="_blank" rel="noreferrer"
                                className="text-white text-decoration-none">
                                <BsTwitterX size={24} />
                            </a>
                        </div>

                    </div>

                </div>

                <hr className="footer-divider my-4" />

                <div className="">

                    <ul className="list-unstyled footer-inline">
                        <li className="footer-inline-separator"><Link to="/privacy-policy">Privacy Policy</Link></li>
                        <li className="footer-inline-separator"><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
                        <li className="footer-inline-separator"><Link to="/refund-cancellation">Refund & Cancellation</Link></li>
                        <li><Link to="/disclaimer">Disclaimer</Link></li>
                    </ul>

                </div>
                <div className="text-center small opacity-75">

                    © {new Date().getFullYear()} Irtika Shrey Consulting. All rights reserved.
                    <br />
                    <span className="text-sits-muted">Crafted with care by Splengo Innovative Technology and Security</span>
                </div>
            </div>
        </footer>

    );
}

export default Footer;
